import { motion } from "framer-motion";
import { SERVICES } from "../data/site";

export const Services = () => (
  <section id="services" data-testid="services-section" className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-32 scroll-mt-16">
    <p className="font-display text-xs uppercase tracking-[0.3em] font-semibold text-[#0047FF] mb-4">Services</p>
    <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-none mb-14 md:mb-20">
      One person. <span className="text-stroke">Full stack creative.</span>
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-black/10">
      {SERVICES.map((s, i) => (
        <motion.div
          key={s.group}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.08 }}
          data-testid={`service-group-${s.group.toLowerCase()}`}
          className="group border-b border-r border-black/10 p-8 md:p-12 bg-white hover:bg-[#0047FF] transition-colors duration-300"
        >
          <div className="flex items-baseline justify-between mb-6">
            <h3 className="font-display font-black text-3xl md:text-4xl tracking-tighter group-hover:text-white transition-colors">{s.group}</h3>
            <span className="font-display text-sm font-bold text-black/20 group-hover:text-white/40 transition-colors">0{i + 1}</span>
          </div>
          <p className="text-black/50 group-hover:text-white/70 mb-6 text-sm md:text-base transition-colors">{s.desc}</p>
          <ul className="flex flex-wrap gap-2">
            {s.items.map((it) => (
              <li key={it} className="text-xs md:text-sm font-semibold px-3.5 py-1.5 rounded-full border border-black/10 group-hover:border-white/30 group-hover:text-white transition-colors">
                {it}
              </li>
            ))}
          </ul>
        </motion.div>
      ))}
    </div>
  </section>
);
